:host {
  display: block;
}

.siteinfo-body {
  background-color: white;
  padding: 10px;
  margin-bottom: 20px;
 
}


 a{
  color: #b71d1d !important;
  font-size: 16px;
  text-decoration: none !important;
  position: relative; 

}